// api/article.js
import apiService from "../services/api";

export const articleAPI = {
  // Получить список всех статей
  getAll: async () => {
    return await apiService.get(`/article/list/`);
  },

  // Получить одну статью по ID
  getById: async (id) => {
    return await apiService.get(`/article/${id}`);
  },

  // Создать новую статью
  create: async (data) => {
    return await apiService.post(`/article/create/`, data);
  },

  // Загрузить файл статьи
  uploadFile: async (file, entityType, entityId, version = 1) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("entity_type", entityType);
    formData.append("entity_id", entityId);
    formData.append("version", version);

    return await apiService.request("/article/article-file/create", {
      method: "POST",
      body: formData,
      headers: {
        // Не указываем Content-Type, браузер сам добавит с boundary для FormData
      },
    });
  },

  // Обновить статью
  update: async (id, data) => {
    return await apiService.put(`/article/${id}`, data);
  },

  // Удалить статью
  delete: async (id) => {
    return await apiService.delete(`/article/${id}`);
  },
};
